package org.example.project.utils

import org.example.project.settings.UISettings
import org.example.project.settings.applyAppButtonActiveChrome
import org.example.project.settings.applyAppButtonChrome
import org.example.project.settings.applyAppButtonHoverChrome
import org.jetbrains.compose.web.css.*

object FormStyles : StyleSheet() {

    val wrapper by style {
        minHeight(100.vh)
        width(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        backgroundColor(Color("#0f1115"))
        color(Color("#f5f5f7"))
        padding(20.px)
        boxSizing("border-box")
    }

    val box by style {
        backgroundColor(rgba(0, 0, 0, 0.5))
        border(1.px, LineStyle.Solid, Color("#dddddd"))
        borderRadius(16.px)
        property("box-shadow", "0 0 12px rgba(255,255,255,0.15)")
        padding(32.px)
        maxWidth(500.px)
        width(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(20.px)
        boxSizing("border-box")
    }

    // ---------- HEADERS ----------
    val h1 by style {
        fontSize(26.px)
        fontWeight("bold")
        textAlign("center")
        color(Color.white)
    }

    val h2 by style {
        fontSize(18.px)
        textAlign("center")
        color(Color("#cccccc"))
    }

    val h3 by style {
        fontSize(15.px)
        fontWeight("normal")
        textAlign("center")
        color(Color("#cccccc"))
        marginBottom(8.px)
    }

    val h4 by style {
        fontSize(26.px)
        fontWeight("normal")
        textAlign("center")
        color(Color("#8b0000"))
        marginBottom(8.px)
    }

    // ---------- INPUT ----------
    val input by style {
        fontSize(16.px)
        width(100.percent)
        minHeight(44.px)
        borderRadius(10.px)
        padding(12.px, 14.px)
        border(1.px, LineStyle.Solid, Color("#dddddd"))
        backgroundColor(Color.transparent)
        color(Color.white)
        fontFamily("inherit")
        boxSizing("border-box")
        property("box-shadow", "inset 0 0 6px rgba(255,255,255,0.15)")

        focus {
            border(2.px, LineStyle.Solid, Color("#f5f5f7"))
            property(
                "box-shadow",
                "0 0 10px rgba(255,255,255,0.3), inset 0 0 6px rgba(255,255,255,0.15)"
            )
            outline("none")
        }
    }

    // ---------- BUTTON ----------
    val button by style {
        padding(12.px, 28.px)
        fontSize(18.px)
        applyAppButtonChrome()
        hover {
            applyAppButtonHoverChrome()
        }
        active {
            applyAppButtonActiveChrome()
        }
    }

    val buttonRow by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        gap(16.px)
        flexWrap(FlexWrap.Wrap)
        marginTop(10.px)
    }

    val screenInfoCard by style {
        backgroundColor(rgba(20, 20, 20, 0.7))
        border(1.px, LineStyle.Solid, Color("#dddddd"))
        borderRadius(12.px)
        property("box-shadow", "0 0 10px rgba(255,255,255,0.15)")
        padding(16.px)
        maxWidth(400.px)
        width(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        gap(12.px)
        cursor("pointer")
        property("transition", "transform 0.2s ease, box-shadow 0.2s ease")

        hover {
            property("transform", "scale(1.03)")
            property("border-color", UISettings.ACCENT)
        }
    }

    val screenInfoImage by style {
        width(100.percent)
        height(180.px)
        borderRadius(10.px)
        property("object-fit", "cover")
        marginBottom(8.px)
    }

    val screenInfoTitle by style {
        fontSize(20.px)
        fontWeight("bold")
        textAlign("center")
        color(Color.white)
    }

    val screenInfoSubtitle by style {
        fontSize(14.px)
        textAlign("center")
        color(Color("#bbbbbb"))
    }


    val datenschutzText by style {
        property("white-space", "pre-wrap")
        property("word-break", "break-word")
        textAlign("left")
        lineHeight("1.4")   // ⬅️ so ist es gültig
    }


}
